import { styled } from '@mui/material';
import { Field, FormikProvider, FormikValues, useFormik } from 'formik';
import {useContext} from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import * as Yup from 'yup';
import Button from '../../../../customs/Button';
import Input from '../../../../customs/FormInput';
import apiCall from '../../../../utils/apiCall';
import { NotificationContext } from '../../../../providers/notification';
import { select } from 'jodit/types/plugins/select/select';
interface ModalProps{
    handleClose: () => void;
}

interface Payload {
    Id: number;
    RouteId: number;
    RouteType: string;
    Messages: string;
    IsActive:boolean;
}

const CreateRouteContent = ({handleClose} : ModalProps) => {
    const { showNotification } = useContext(NotificationContext);
    const queryClient = useQueryClient();

    const createRoutePageEditor = async (data: Payload) => {
        return await(apiCall().post('/SetUp/CreateRoutePageEditor', data));
    };

    const createRouteMutation = useMutation(['create-route-page-editor'], createRoutePageEditor, {retry: 0});

    const createRoutePageEditorHandler = async (values: FormikValues, resetForm: () => void) => {
        const payload: Payload = {
            RouteType: values?.name,
            Id: 0,
            RouteId: 0,
            Messages: '',
            IsActive: false
        };

        try {
            await createRouteMutation.mutateAsync(payload, {
                onSuccess: () => {
                    showNotification({
                        type: 'success',
                        message: ' Route Page Created Successfully'
                    });
                    resetForm();
                    queryClient.refetchQueries(['get-all-routes-route-page-editor']);
                }
            })
        } catch(error: any) {
            showNotification({
                type: 'error',
                message: error?.response?.data?.Message || error?.message,
            })
        }
    }

    const validationSchema = Yup.object().shape({
        name: Yup.string().matches(/^[A-Za-z\s!@#$%^&*()/]+$/, 'Only text is allowed').required('required'),
    })

    const formik = useFormik<FormikValues>({
        initialValues:{
            name: "",
        },
        onSubmit: (values, {resetForm}) => {
            createRoutePageEditorHandler(values, resetForm);
        },
        validationSchema
    })
  return (
    <FormikProvider value={formik}>
        <form onSubmit={formik.handleSubmit}>
            <FormWrapper>
                <Field
                    name="id"
                    type="number"
                    placeholder="id"
                />
                <Field
                    name="routetype"
                    type="text"
                    placeholder="route type"
                />
                <textarea
                    name="messages"
                />
                {/* <Field
                    name="status"
                    type="text"
                    as={onselect}
                    label={"Status"}
                />  */}
            </FormWrapper>
            <ButtonWrapper>
                <ButtonContainer>
                    <StyledButton text='Cancel' onClick={handleClose}/>
                    <StyledButton 
                        type="submit" 
                        text={createRouteMutation.isLoading ? 'Submitting' : 'Submit'} 
                        disabled={createRouteMutation.isLoading} 
                    />
                </ButtonContainer>
            </ButtonWrapper>
        </form>
    </FormikProvider>
  )
}

export default CreateRouteContent

const FormWrapper = styled('div')`
    margin-inline: 3.5rem;
`

const ButtonWrapper = styled('div')`
    display: flex;
    justify-content: flex-end;
    margin-block: 2.5rem;
    padding-inline: 3.5rem;
`

const ButtonContainer = styled('div')`
    display: flex;
    gap: 2rem;
`

const StyledButton = styled(Button)`
    padding-block: 1rem;
    padding-inline: 2rem;
`

